import { action, global } from '../const';
import { getServerResponse, onException } from '../functions';



// [#172 WoogiConnectInvite.getTokenForSendingEmail]
export const getTokenForSendingEmail = () => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WoogiConnectInvite.getTokenForSendingEmail",
                user_id: userInfo.id
            })
            dispatch({
                type: action.INVITE_E_TOKEN,
                etoken: response.etoken
            })
            return response.etoken;
        } catch (error) {
            onException(error)
        }
        return "";
    }
};


// [#162 WoogiConnectInvite.getMessageTemplate]
export const getMessageTemplate = (role_type, email) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { etoken, templateChild, templateParent, templateGrandparent, templateMentor, templateTeacher } = getState().invite;
        try {
            if (role_type === 0 && templateChild) return;
            else if (role_type === 1 && templateParent) return;
            else if (role_type === 2 && templateGrandparent) return;
            else if (role_type === 3 && templateMentor) return;
            else if (role_type === 4 && templateTeacher) return;

            if (!etoken) etoken = await dispatch(getTokenForSendingEmail());
            let response = await getServerResponse({
                cmd: "WoogiConnectInvite.getMessageTemplate",
                token: userInfo.token,
                role_type,
                etoken,
                email
            })
            let role = "templateChild";
            if (role_type === 1) role = "templateParent"
            else if (role_type === 2) role = "templateGrandparent"
            else if (role_type === 3) role = "templateMentor"
            else if (role_type === 4) role = "templateTeacher"

            if (response.status === 200)
                dispatch({
                    type: action.INVITE_MESSAGE_TEMPLATE,
                    message: response.message_template,
                    role
                })
        } catch (error) {
            onException(error)
        }

    }
};

// [#161 WoogiConnectInvite.sendMessage]
export const sendMessage = (mail_address, role_type) => {
    return async (dispatch, getState) => {
        let invite = getState().invite;
        let { etoken } = getState().invite;
        try {
            if (!etoken) etoken = await dispatch(getTokenForSendingEmail());
            let message = "";
            if (role_type === 0) message = invite.templateChild
            else if (role_type === 1) message = invite.templateParent
            else if (role_type === 2) message = invite.templateGrandparent
            else if (role_type === 3) message = invite.templateMentor
            else if (role_type === 4) message = invite.templateTeacher
            
            let response = await getServerResponse({
                cmd: "WoogiConnectInvite.sendMessage",
                message,
                mail_address,
                role_type,
                etoken: invite.etoken
            })
            return response.status;
        } catch (error) {
            onException(error)
        }
        return 203;
    }
};